import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CoursePage from '../components/Course/CoursePage/CoursePage';
import Courses from '../components/Course/Courses';
import CourseOfferPage from '../components/courseOffer/CourseOfferPage';
import CourseOffers from '../components/courseOffer/CourseOffers';
import CreatorPage from '../components/CreatorPage/CreatorPage';
import Creators from '../components/CreatorPage/Creators';
import CancelInternalEnrolments from '../components/CreatorRevenuePage/CancelInternalEnrolments';
import EnrolmentTracking from '../components/EnrolmentTracking';
import Feedback from '../components/feedback/Feedback';
import FeedbackPage from '../components/feedback/FeedbackPage';
import FeedbackPageBySurveyId from '../components/feedback/FeedbackPageBySurveyId';
import LearnerPage from '../components/Learner/LearnerPage';
import Learners from '../components/Learner/Learners';
import Login from '../components/Login/Login';
import MergeAccounts from '../components/MergeAccounts/MergeAccounts';
import ReleaseNotesPage from '../components/ReleaseNotes/ReleaseNotesPage';
import ResetPassword from '../components/ResetPassword/ResetPassword';
import ShortUrlWrapper from '../components/short_url/ShortUrl';
import SubunitPage from '../components/Subunits/SubunitPage/SubunitPage';
import Subunits from '../components/Subunits/Subunits';
import TrainerInfo from '../components/TrainerPage/TrainerInfo';
import Trainers from '../components/TrainerPage/Trainers';
import TrialClass from '../components/TrialClass';
import ClassPage from '../components/TrialClass/Class/ClassPage/ClassPage';
import UnitOffer from '../components/unitOffer/UnitOffer';
import UnitOffers from '../components/unitOffer/UnitOffers';
import UnitPage from '../components/Units/UnitPage/UnitPage';
import Units from '../components/Units/Units';
import { UserProfile } from '../components/UserProfile/UserProfile';
import AddFreeworkshop from '../pages/AddFreeworkshopPage';
import Alumni from '../pages/Alumni/Alumni';
import CloneCourseOfferContainer from '../pages/CloneCourseOfferPage/CloneCourseOfferContainer';
import Comments from '../pages/Comments/Comments';
import CommunitiesApplicationPage from '../pages/CommunitiesApplication/CommunitiesApplicationPage';
import StartCommunityApplicationPage from '../pages/StartCommunityApplication/StartCommunityApplicationPage';
import CommunityMailLogs from '../pages/CommunityMailLogs/CommunityMailLogsPage';
import CommunityEventListPage from '../pages/CommunityEvents/CommunityEventListPage';
import CommunityEventPage from '../pages/CommunityEvents/CommunityEventPage';
import CommunityResourceListPage from '../pages/CommunityResources/CommunityResourceListPage';
import CommunityResourcePage from '../pages/CommunityResources/CommunityResourcePage';
import CourseApplicationsPage from '../pages/CourseApplications/CourseApplicationsPage';
import CourseOfferAnnouncements, {
  SingleCourseOfferAnnouncementContainer
} from '../pages/CourseOfferAnnouncements';
import EmailTemplates from '../pages/EmailTemplatesPage/EmailTemplatesContainer';
import LearnerSocialMediaPage from '../pages/LearnerSocialMediaPage';
import PricingOptions from '../pages/PricingOptions/PricingOptions';
import PromoCodes from '../pages/Promo';
import PromoCodeDetailPage from '../pages/Promo/PromoCodeDetailPage';
import Refund from '../pages/Refunds/Refunds';
import TrainerPublicProfile from '../pages/TrainerPublicProfilePage/TrainerPublicProfile';
import PrivateRoute from './PrivateRoute';

// const EmailTemplates = lazy(() =>
//   import("../pages/EmailTemplatesPage/EmailTemplatesContainer")
// );

const AdminRouter = () => (
  <Switch>
    <Route exact path="/login">
      <Login />
    </Route>
    <PrivateRoute exact path="/">
      <ReleaseNotesPage />
    </PrivateRoute>
    <PrivateRoute exact path="/feedback">
      <Feedback />
    </PrivateRoute>
    <PrivateRoute exact path="/feedback/:id">
      <FeedbackPage />
    </PrivateRoute>
    <PrivateRoute exact path="/answers/feedback/:id">
      <FeedbackPageBySurveyId />
    </PrivateRoute>
    <PrivateRoute path="/short-url">
      <ShortUrlWrapper />
    </PrivateRoute>
    <PrivateRoute path="/reset-password">
      <ResetPassword />
    </PrivateRoute>
    <PrivateRoute path="/refunds">
      <Refund />
    </PrivateRoute>
    <PrivateRoute path="/alumni">
      <Alumni />
    </PrivateRoute>
    <PrivateRoute exact path="/course-applications">
      <CourseApplicationsPage />
    </PrivateRoute>
    <PrivateRoute path="/courses">
      <Courses />
    </PrivateRoute>
    <PrivateRoute path="/comments">
      <Comments />
    </PrivateRoute>
    <PrivateRoute path="/course/:courseId">
      <CoursePage />
    </PrivateRoute>
    <PrivateRoute path="/course-offers">
      <CourseOffers />
    </PrivateRoute>
    <PrivateRoute path="/pricing-options">
      <PricingOptions />
    </PrivateRoute>
    <PrivateRoute
      exact
      path="/course-offer/:id"
      component={CourseOfferPage}
    />
    <PrivateRoute
      exact
      path="/course-offer/:id/clone"
      component={CloneCourseOfferContainer}
    />
    <PrivateRoute path="/units">
      <Units />
    </PrivateRoute>
    <PrivateRoute path="/unit/:unitId">
      <UnitPage />
    </PrivateRoute>
    <PrivateRoute path="/unit-offers">
      <UnitOffers />
    </PrivateRoute>
    <PrivateRoute path="/subunits">
      <Subunits />
    </PrivateRoute>
    <PrivateRoute path="/subunit/:subunitId">
      <SubunitPage />
    </PrivateRoute>
    <PrivateRoute path="/trainers">
      <Trainers />
    </PrivateRoute>
    <PrivateRoute path="/trainer/:id">
      <TrainerInfo />
    </PrivateRoute>
    <PrivateRoute path="/trainer-public-profiles">
      <TrainerPublicProfile />
    </PrivateRoute>
    <PrivateRoute path="/unit-offer/:id">
      <UnitOffer />
    </PrivateRoute>
    <PrivateRoute path="/learners">
      <Learners />
    </PrivateRoute>
    <PrivateRoute path="/learners-social-media">
      <LearnerSocialMediaPage />
    </PrivateRoute>
    <PrivateRoute path="/learner/:id">
      <LearnerPage />
    </PrivateRoute>
    <PrivateRoute path="/enrolments" component={EnrolmentTracking} />
    <PrivateRoute path="/email-templates" component={EmailTemplates} />
    <PrivateRoute exact path="/trial-class">
      <TrialClass />
    </PrivateRoute>
    <PrivateRoute exact path="/trial-class/:classCode">
      <ClassPage />
    </PrivateRoute>
    <PrivateRoute exact path="/user">
      <UserProfile />
    </PrivateRoute>
    <PrivateRoute exact path="/promo">
      <PromoCodes />
    </PrivateRoute>
    <PrivateRoute exact path="/promo/:promoId">
      <PromoCodeDetailPage />
    </PrivateRoute>
    <PrivateRoute exact path="/promo">
      <PromoCodes />
    </PrivateRoute>
    <PrivateRoute exact path="/course-offer-announcements">
      <CourseOfferAnnouncements />
    </PrivateRoute>
    <PrivateRoute exact path="/course-offer-announcements/:announcementId">
      <SingleCourseOfferAnnouncementContainer />
    </PrivateRoute>
    <PrivateRoute exact path="/creators">
      <Creators />
    </PrivateRoute>
    <PrivateRoute exact path="/creator/:university">
      <CreatorPage />
    </PrivateRoute>
    <PrivateRoute exact path="/creator-revenue">
      <CancelInternalEnrolments />
    </PrivateRoute>
    <PrivateRoute exact path="/add-freeworkshop">
      <AddFreeworkshop />
    </PrivateRoute>
    <PrivateRoute exact path="/merge-accounts">
      <MergeAccounts />
    </PrivateRoute>
    <PrivateRoute exact path="/community-applications">
      <CommunitiesApplicationPage />
    </PrivateRoute>
    <PrivateRoute exact path="/community-mail-logs">
      <CommunityMailLogs />
    </PrivateRoute>
    <PrivateRoute exact path="/start-community-applications">
      <StartCommunityApplicationPage />
    </PrivateRoute>
    <PrivateRoute exact path="/community/events">
      <CommunityEventListPage />
    </PrivateRoute>
    <PrivateRoute exact path="/community/event/:id">
      <CommunityEventPage />
    </PrivateRoute>
    <PrivateRoute exact path="/community/resources">
      <CommunityResourceListPage />
    </PrivateRoute>
    <PrivateRoute exact path="/community/resource/:id">
      <CommunityResourcePage />
    </PrivateRoute>
  </Switch>
);

export default AdminRouter;
